import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=0916840a&scoped=true&"
import script from "./AddForm.vue?vue&type=script&lang=js&"
export * from "./AddForm.vue?vue&type=script&lang=js&"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=0916840a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916840a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0916840a')) {
      api.createRecord('0916840a', component.options)
    } else {
      api.reload('0916840a', component.options)
    }
    module.hot.accept("./AddForm.vue?vue&type=template&id=0916840a&scoped=true&", function () {
      api.rerender('0916840a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/modules/components/AddForm.vue"
export default component.exports